import { render, staticRenderFns } from "./JobBoardDetails.vue?vue&type=template&id=76a2608e&"
import script from "./JobBoardDetails.vue?vue&type=script&lang=js&"
export * from "./JobBoardDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobBoardDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports